"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonValueSchema = void 0;
const zod_1 = require("zod");
exports.JsonValueSchema = zod_1.z.lazy(() => zod_1.z.union([
    zod_1.z.string(),
    zod_1.z.number().finite(),
    zod_1.z.boolean(),
    zod_1.z.null(),
    zod_1.z.array(exports.JsonValueSchema),
    zod_1.z.record(zod_1.z.string(), exports.JsonValueSchema),
]));
//# sourceMappingURL=jsonValue.js.map